// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:42.268Z
// Property: LYNX Gate City (ID: 6767906449165577)
// Collections: 18 amenities, 19 floorplans (live), 63 photos, 25 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449165577",
  "property_external_id": "5494326",
  "property_zillow_url": "https://www.zillow.com/apartments/greensboro-nc/the-park-at-aventino/5Xk5S4/",
  "property_apartments_url": "https://www.apartments.com/the-park-at-aventino-greensboro-nc/x40dmlm/",
  "property_google_business_url": "https://www.google.com/maps/place/Lynx+Gate+City/data=!4m2!3m1!1s0x0:0xc186d7dd23688422?sa=X&ved=2ahUKEwjSz9Grz7ySAxUxdUEAHV_8ABMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "16233550907",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "lynx-gate-city",
  "property_name": "LYNX Gate City",
  "property_website_url": "https://www.lynxgatecity.com/",
  "property_domain": "https://www.lynxgatecity.com/",
  "property_address": "2826 Vanstory Street",
  "property_full_address": "2826 Vanstory St, Greensboro, NC 27407",
  "property_address_1": "2826 Vanstory Street",
  "property_address_2": null,
  "property_address_city": "Greensboro",
  "property_address_state": "NC",
  "property_address_zip_full": "27407-4608",
  "property_address_zip": "27407",
  "property_address_country": "US",
  "property_address_county": "Guilford County",
  "property_neighborhood_address": "Outer Northwest I-40 Corridor",
  "property_address_latitude": "36.0363214",
  "property_address_longitude": "-79.8478402",
  "property_email": "lynxgatecity@rrliving.com",
  "property_phone": "(336) 447-3524",
  "property_call_tracking_phone": "336-594-2669",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At LYNX Gate City in Greensboro, NC, your ideal lifestyle awaits. Choose from one or two-bedroom layouts with spacious closets and modern amenities. Unwind at our expansive fitness center, take a dip in the pool, or enjoy a barbecue in our scenic picnic area. Ready to elevate your living? Explore our availability today!",
  "property_long_description": "Meet LYNX Gate City, your fresh, new address in Greensboro, North Carolina. Our garden style community brings you an inviting 1 & 2 bedroom apartment home in a notable neighborhood. From exploring exciting territory around town or keeping it close to home by taking advantage of a swimming pool, you’ll always have something to look forward to when you live at LYNX Gate City.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-a483-7366-b4e6-8b3fb9612388.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of apartment building with balconies and brick accents.",
    "public_id": "019e1dd4-a483-7366-b4e6-8b3fb9612388",
    "storage_key": "property/6767906449165577/019e1dd4-a483-7366-b4e6-8b3fb9612388.webp",
    "width": 1920,
    "height": 1080
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.16666666666667",
  "property_admin_fee": null,
  "property_application_fee": "65",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "4",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed, maximum 2 of each per unit.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://www.lynxgatecity.loftliving.com/login",
  "property_apply_now_url": "https://9201310.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-a368-77d9-b98d-cd29924a6cad.webp",
  "property_primary_logo_media": {
    "alt_text": "Lynx Gate City logo",
    "public_id": "019e1dd4-a368-77d9-b98d-cd29924a6cad",
    "storage_key": "property/6767906449165577/019e1dd4-a368-77d9-b98d-cd29924a6cad.webp",
    "width": 450,
    "height": 253
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-a7a8-74ae-b017-8f409bd1e789.webp",
  "property_secondary_logo_media": {
    "alt_text": "Lynx Gate City logo",
    "public_id": "019e1dd4-a7a8-74ae-b017-8f409bd1e789",
    "storage_key": "property/6767906449165577/019e1dd4-a7a8-74ae-b017-8f409bd1e789.webp",
    "width": 1920,
    "height": 1080
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-a7a8-74ae-b017-8f409bd1e789.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Lynx Gate City logo",
    "public_id": "019e1dd4-a7a8-74ae-b017-8f409bd1e789",
    "storage_key": "property/6767906449165577/019e1dd4-a7a8-74ae-b017-8f409bd1e789.webp",
    "width": 1920,
    "height": 1080
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e8e86-bfe6-7749-8653-b2fa03454b31.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-bfe6-7749-8653-b2fa03454b31",
    "storage_key": "property/6767906449165577/019e8e86-bfe6-7749-8653-b2fa03454b31.webp",
    "width": 450,
    "height": 253
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#34495e",
  "property_secondary_color": "#d9a760",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "758 - 1186",
  "property_sqft_min": "758",
  "property_sqft_max": "1186",
  "property_price_range": "1155 - 1745",
  "property_price_min": "1155",
  "property_price_max": "1745",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/lynxgatecity",
  "property_instagram_url": "https://www.instagram.com/lynxgatecity/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJpTqhvzkaU4gRIoRoI93XhsE",
  "property_youtube_url": "https://www.youtube.com/shorts/juVnWgwkBKQ",
  "property_yelp_url": "https://www.yelp.com/biz/ashbrook-pointe-apartments-greensboro",
  "property_tiktok_url": "https://www.tiktok.com/content/lynx-gate-city-apartments-greensboro",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Lynx Gate City",
  "property_home_romance_title": "Embrace Harmony in Your Ideal Apartment Community Today!",
  "property_home_amenities_blurb": "<p>Meet Lynx Gate City, your fresh, new address in Greensboro, North Carolina. Our garden style community brings you an inviting 1 & 2 bedroom apartment home in a notable neighborhood. From exploring exciting territory around town or keeping it close to home by taking advantage of a swimming pool, you’ll always have something to look forward to when you live at Lynx Gate City.</p>",
  "property_home_floorplans_blurb": "<p>Let Greensboro, North Carolina, be the focal point of your experiential life. With a neighborhood as unique as you are like Rolling Roads Greensboro, you’re bound to find something special around every corner – from shopping local markets and exploring nearby parks on the weekends to swiftly commuting to major employment hubs any time. This is where you want to plant roots.</p>",
  "property_home_gallery_blurb": "Welcome to Lynx Gate City in Greensboro, NC, where comfort meets convenience. Choose from spacious one- or two-bedroom floor plans featuring modern amenities like a fitness center, beautiful picnic area, and pet-friendly spaces. Enjoy 24-hour access, emergency maintenance, and online services. Picture yourself living here and enjoying life's little pleasures!",
  "property_home_neighborhood_blurb": "<p><strong>Greensboro at your doorstep.</strong> From LYNX Gate City in Rolling Roads, local markets, weekend green spaces, and everyday conveniences are all within easy reach. Major employment hubs are a smooth commute away, giving this Vanstory Street address the right mix of connected and rooted.</p>",
  "property_home_reviews_blurb": "At Lynx Gate City in Greensboro, NC, you’ll find a friendly community where “the staff knows your name and is willing to help you in any way.” Spacious one-bedroom apartments, fast maintenance, and exciting social activities make for an exceptional living experience. Join us and see why our residents love calling us home!",
  "property_neighborhood_blurb": "<p>Let Greensboro, North Carolina, be the focal point of your experiential life. With a neighborhood as unique as you are like Rolling Roads Greensboro, you’re bound to find something special around every corner – from shopping local markets and exploring nearby parks on the weekends to swiftly commuting to major employment hubs any time. This is where you want to plant roots.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Lynx Gate City, we know that amenities matter. Modern life feels incomplete without a collection of community conveniences that simplify your day-to-day routine in Greensboro, North Carolina. From central a/c inside your garden style home to a swimming pool right at your doorstep, you’ll have so many ways to live the good life in Guilford County.</p>",
  "property_applynow_blurb": "At LYNX Gate City in Greensboro, NC, vibrant living awaits with spacious one and two-bedroom floor plans. Enjoy top-tier amenities like a resort-style pool, expansive fitness center, and community dog park. Embrace comfort and convenience—lease online today and experience a lifestyle tailored to you!",
  "property_contactus_blurb": "At LYNX Gate City in Greensboro, NC, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience modern living in a vibrant community. Have questions? Our leasing team is ready to assist you in finding your perfect home. Connect with us today!",
  "property_faqs_blurb": "At LYNX Gate City in Greensboro, NC, our thoughtfully designed floor plans range from cozy one-bedroom retreats to spacious two-bedroom havens. Have questions? Our FAQs page is your go-to resource for insights into our vibrant community and amenities. Your perfect home awaits—let us guide you!",
  "property_floorplans_blurb": "<p>Thoughtfully designed floor plans sync with a cozy interior in every 1 & 2 bedroom home at Lynx Gate City. From the moment you open your front door, you’ll feel a sense of belonging. Regardless of your routine, this is a place that offers a comfy retreat from the busyness of your day-to-day life. Click through our collection of floor plans to find one that’s just right for you and your lifestyle.</p>",
  "property_gallery_blurb": "<p>Meet our garden style community in photo form. As you browse through our virtual gallery, get a glimpse of what your life could look like with a refreshing apartment home, a variety of convenient on-site amenities, and a storied neighborhood location. When you’re ready, head to our <a href=\"/floor-plans/\">Floor Plans page</a> to pick your ideal apartment home, or <a href=\"/contact/\">reach out to our leasing team</a> and schedule a tour of Lynx Gate City.</p>",
  "property_interactivemap_blurb": "At LYNX Gate City in Greensboro, NC, your ideal apartment awaits! Choose from spacious one- or two-bedroom floor plans infused with modern amenities. Dive into our expansive fitness center, unwind at the pool, or enjoy gatherings at the BBQ area. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At LYNX Gate City in Greensboro, NC, your perfect home awaits—choose from spacious one or two-bedroom floor plans. Enjoy vibrant living alongside great friends who make our community shine. Don’t keep this gem to yourself; refer a friend today and enhance your neighborhood experience!",
  "property_residentaccess_blurb": "At LYNX Gate City in Greensboro, NC, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle needs. Effortlessly manage your residency through our resident portal—pay rent, schedule maintenance, and stay connected. Your vibrant community awaits; take the next step towards comfortable living today!",
  "property_reviews_blurb": "At Lynx Gate City in Greensboro, NC, our residents rave about the spacious one-bedroom apartments and the welcoming community. “The staff knows your name and is willing to help!” With hassle-free maintenance and engaging social activities, living here is a decision you’ll love. Join a neighborhood where you truly belong!",
  "property_created_at": "1744732041823",
  "property_scheduletour_blurb": "Experience the charm of LYNX Gate City in Greensboro, NC, where our thoughtfully designed one and two-bedroom floor plans offer ideal spaces for modern living. Ready to make the leap? Schedule a tour today and hear firsthand from our residents about life in this vibrant community!",
  "property_thankyou_blurb": "Thank you for your interest in LYNX Gate City, where your ideal lifestyle awaits in Greensboro, NC! From cozy one-bedroom retreats to spacious two-bedroom homes, our thoughtfully designed floor plans cater to every need. Expect a prompt follow-up from our team to guide you on your next steps.",
  "property_virtualtours_blurb": "<p>See more of what’s in store for you at Lynx Gate City with a virtual tour. It’s the next best thing to actually being here.</p>",
  "property_copyright": "2025 All Rights Reserved. The Park at Aventino",
  "property_seo_title_home": "LYNX Gate City |  Apartments in Greensboro, NC",
  "property_seo_description_home": "Experience vibrant living at LYNX Gate City in Greensboro! Enjoy spacious floor plans, a resort-style pool, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Greensboro, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at LYNX Gate City in Greensboro, NC. Browse our unique one and two-bedroom floor plans, designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Greensboro, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience LYNX Gate City in Greensboro, NC—where modern living meets comfort! Enjoy a pool, fitness center, and pet-friendly perks. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Greensboro, NC",
  "property_seo_description_gallery": "Experience vibrant living at LYNX Gate City in Greensboro, NC—modern amenities, pet-friendly vibes, and stunning spaces await!",
  "property_seo_title_virtualtours": "Virtual Tours | LYNX Gate City Apartments",
  "property_seo_description_virtualtours": "Step inside LYNX Gate City in Greensboro, NC! Experience our stylish one and two-bedroom apartments through an immersive virtual tour. Your ideal space awaits!",
  "property_seo_title_interactivemap": "Interactive Map | LYNX Gate City Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at LYNX Gate City, where luxury meets comfort in Greensboro, NC. Enjoy pet-friendly amenities, expansive fitness options, and more!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Greensboro, NC",
  "property_seo_description_neighborhood": "Experience vibrant living at LYNX Gate City in Greensboro, NC. Uncover hidden gems and local favorites surrounding our one and two-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | LYNX Gate City",
  "property_seo_description_contact": "Connect with LYNX Gate City in Greensboro, NC. Our one and two-bedroom apartments await your inquiry. Reach out to our leasing team with questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Greensboro, NC",
  "property_seo_description_faqs": "Get informed at LYNX Gate City! From spacious floor plans to pet-friendly amenities like a leash-free park, our FAQs cover everything you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Greensboro, NC",
  "property_seo_description_reviews": "Discover LYNX Gate City in Greensboro, NC! Explore resident reviews and see why our spacious apartments and amenities feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Greensboro, NC",
  "property_seo_description_applynow": "Experience vibrant living at LYNX Gate City in Greensboro, NC. Enjoy spacious floor plans, resort-style amenities, and pet-friendly perks. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | LYNX Gate City",
  "property_seo_description_residentaccess": "Access the LYNX Gate City resident portal for easy rent payments, maintenance requests, and community updates. Convenience is just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | LYNX Gate City",
  "property_seo_description_referafriend": "Great friends make great neighbors at LYNX Gate City! Refer a friend today and enjoy exclusive perks in beautiful Greensboro, NC. Join our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | LYNX Gate City",
  "property_seo_description_scheduletour": "Experience modern living at LYNX Gate City in Greensboro, NC. Schedule a tour today and step into your future home surrounded by comfort and convenience!",
  "property_seo_title_privacy": "Privacy Policy | LYNX Gate City",
  "property_seo_description_privacy": "At LYNX Gate City in Greensboro, NC, your privacy is our priority. Uncover how we safeguard your information. View our privacy policy for details!",
  "property_seo_title_accessibility": "Website Accessibility | LYNX Gate City",
  "property_seo_description_accessibility": "Join LYNX Gate City in Greensboro, NC—where accessibility meets comfort and digital inclusion is a priority. Embrace our welcoming community!",
  "property_seo_title_sitemap": "Sitemap | LYNX Gate City",
  "property_seo_description_sitemap": "Navigate your way to your dream home at LYNX Gate City in Greensboro, NC. Check out our sitemap to explore every exciting corner of our vibrant community!",
  "property_seo_title_thankyou": "Thank You | LYNX Gate City",
  "property_seo_description_thankyou": "Thank you for contacting LYNX Gate City! Our friendly team will respond promptly as you begin your apartment journey. Find your new home soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Greensboro, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293565056",
  "amenities": [
    {
      "id": "ec_309bbaf4c0877cc1c143ceac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f99ca5fbc859ab0a0da5dfc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8f9af6890aef4d0d0ee0e01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Package Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e28fb58ec6a19bfec07c17d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7451124adfaf9631d7b703d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e66bfece7bc047adffbfee4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Entertainment Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4967d95615a0d859513dd12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da8f49ec40ac073ed10df04f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca3507ce2bf3ef709b26cbc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Leash Free Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_426fd25a51d46fd157043d5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3015d6fef0e538398c7f1ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d09f610d1b9fc7ae2d1791e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Efficient Dishwasher & Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a6f7a3d041b8acc48b92e1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "USB Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57483f2d869084a274f782b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Alarm System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e26790097f99ac059e5a04c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Central A/C",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_219fcf031caa3a6275b83204",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fb74f3f2c2cdd23ac7b47d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Washers & Dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87fdc7ed57e679f3b72e737e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_52867405-2e5c-4429-940d-a9ffbd60911d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-929b-74aa-ad4a-136e3d1f1c65.webp",
      "image_media": {
        "alt_text": "Lynx Gate City leasing office entrance with signage and landscaping.",
        "public_id": "019e60fa-929b-74aa-ad4a-136e3d1f1c65",
        "storage_key": "property/6767906449165577/019e60fa-929b-74aa-ad4a-136e3d1f1c65.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "Welcome to Lynx Gate City, where our leasing office is ready to assist you. Visit us to find your perfect apartment home.",
      "link": "",
      "alt_text": "Lynx Gate City leasing office entrance with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_103c0768-685b-4336-952d-100fea7d26a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-3cdb-71ea-9e81-add8258e45a7.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weightlifting equipment, and a spacious workout area.",
        "public_id": "01a06d7f-3cdb-71ea-9e81-add8258e45a7",
        "storage_key": "property/6767906449165577/01a06d7f-3cdb-71ea-9e81-add8258e45a7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide range of cardio and strength training equipment for a complete workout experience.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio machines, weightlifting equipment, and a spacious workout area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0b2e4e6-398e-4cb2-8e0b-d229393ac110",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-4042-75bc-bc47-a4d41975a770.webp",
      "image_media": {
        "alt_text": "Spacious living area with dining table, kitchen island with bar stools, and a living room area.",
        "public_id": "01a06d7f-4042-75bc-bc47-a4d41975a770",
        "storage_key": "property/6767906449165577/01a06d7f-4042-75bc-bc47-a4d41975a770.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a dining area, a modern kitchen with a breakfast bar, and a comfortable living room, perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious living area with dining table, kitchen island with bar stools, and a living room area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef6586ac-4d56-4203-87f4-45a25b09e085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-43b9-70b3-aa3d-062bafa47981.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island.",
        "public_id": "01a06d7f-43b9-70b3-aa3d-062bafa47981",
        "storage_key": "property/6767906449165577/01a06d7f-43b9-70b3-aa3d-062bafa47981.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, stainless steel appliances, and an island, seamlessly flowing into the living area.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc2b6de5-4ead-46e9-962e-ca7cc0e1c662",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-447f-734c-8063-6f7cef78fb73.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and bar seating.",
        "public_id": "01a06d7f-447f-734c-8063-6f7cef78fb73",
        "storage_key": "property/6767906449165577/01a06d7f-447f-734c-8063-6f7cef78fb73.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring white cabinetry, elegant granite countertops, stainless steel appliances, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0b0c13c-fac3-4f4b-8c19-3217cb77f364",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-42fc-70fb-9917-6300ca58fb6f.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with neutral-toned sofa, coffee table, and white cabinets.",
        "public_id": "01a06d7f-42fc-70fb-9917-6300ca58fb6f",
        "storage_key": "property/6767906449165577/01a06d7f-42fc-70fb-9917-6300ca58fb6f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A beautifully appointed living room and kitchen area featuring a comfortable sofa, a stylish coffee table, and a modern kitchen with white cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area with neutral-toned sofa, coffee table, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d231ffb8-fee1-4515-8038-c1b184e725cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-4470-7583-9fd3-2afa5930c32f.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, nightstands, ceiling fan, and a large window.",
        "public_id": "01a06d7f-4470-7583-9fd3-2afa5930c32f",
        "storage_key": "property/6767906449165577/01a06d7f-4470-7583-9fd3-2afa5930c32f.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Cozy and inviting apartment bedroom featuring a comfortable queen-size bed, elegant nightstands, a modern ceiling fan, and ample natural light from a large window.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, nightstands, ceiling fan, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_030e32f1-ba2a-43ca-b72c-6aaae7b05662",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-446b-7381-9775-ed68cc0d3f47.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "01a06d7f-446b-7381-9775-ed68cc0d3f47",
        "storage_key": "property/6767906449165577/01a06d7f-446b-7381-9775-ed68cc0d3f47.webp",
        "width": 1539,
        "height": 1022
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment bathroom, featuring a modern vanity, toilet, and a clean, inviting shower area.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4aa6d69-71b4-4bc0-83ab-fbceb5fbc209",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-402f-7099-89cb-6b88a6534317.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, modern black faucet, and mirror. Shelving unit with towels and baskets next to it. Bedroom visible through doorway.",
        "public_id": "01a06d7f-402f-7099-89cb-6b88a6534317",
        "storage_key": "property/6767906449165577/01a06d7f-402f-7099-89cb-6b88a6534317.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Elegantly appointed bathroom featuring a vanity with granite countertops and ample storage, complemented by a well-organized shelving unit. A glimpse into the serene bedroom offers a comfortable living space.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, modern black faucet, and mirror. Shelving unit with towels and baskets next to it. Bedroom visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52716907-8a48-42b9-a430-a2e0f44845be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e8ee4-96f1-71dc-8a67-643d59b18dab.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, next to a building with a white facade and dark accents.",
        "public_id": "019e8ee4-96f1-71dc-8a67-643d59b18dab",
        "storage_key": "property/6767906449165577/019e8ee4-96f1-71dc-8a67-643d59b18dab.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect spot for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, next to a building with a white facade and dark accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd23230f-cafa-4397-b2be-b1694ee778c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-4302-71f2-8394-71a4ce8d4351.webp",
      "image_media": {
        "alt_text": "Community kitchen and dining area with stainless steel appliances, white cabinets, and a large wooden table with blue chairs.",
        "public_id": "01a06d7f-4302-71f2-8394-71a4ce8d4351",
        "storage_key": "property/6767906449165577/01a06d7f-4302-71f2-8394-71a4ce8d4351.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stylish community kitchen and dining area featuring modern appliances, ample counter space, and a comfortable seating arrangement perfect for resident gatherings.",
      "link": "",
      "alt_text": "Community kitchen and dining area with stainless steel appliances, white cabinets, and a large wooden table with blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7f54483-1d98-440e-815f-4b8507f9b9a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fc-21f0-779a-8e17-0e244a24c195.webp",
      "image_media": {
        "alt_text": "Modern building with large windows and modern landscaping.",
        "public_id": "019e60fc-21f0-779a-8e17-0e244a24c195",
        "storage_key": "property/6767906449165577/019e60fc-21f0-779a-8e17-0e244a24c195.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "The exterior of a modern building, featuring large glass windows and well-maintained landscaping. This building is part of a community that offers a blend of contemporary design and natural beauty.",
      "link": "",
      "alt_text": "Modern building with large windows and modern landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3c5af5a-55f2-4a0a-a441-e35d125c5390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/01a06d7f-43b4-7607-a8ef-e206e4d335db.webp",
      "image_media": {
        "alt_text": "Modern gym with weight machines, free weights, and a large window overlooking the property.",
        "public_id": "01a06d7f-43b4-7607-a8ef-e206e4d335db",
        "storage_key": "property/6767906449165577/01a06d7f-43b4-7607-a8ef-e206e4d335db.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of equipment to help you stay active and reach your wellness goals.",
      "link": "",
      "alt_text": "Modern gym with weight machines, free weights, and a large window overlooking the property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6670a7d-2c98-4b32-a310-f8bc2d30c9fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-d007-75ad-9c82-43db38bdf70a.webp",
      "image_media": {
        "alt_text": "Modern gym with weight machines, punching bag, and dumbbells.",
        "public_id": "019e60fa-d007-75ad-9c82-43db38bdf70a",
        "storage_key": "property/6767906449165577/019e60fa-d007-75ad-9c82-43db38bdf70a.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a wide array of cardio and strength training equipment for residents to enjoy.",
      "link": "",
      "alt_text": "Modern gym with weight machines, punching bag, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b05601a-4fe5-4e0b-be3b-fc9ca9e189ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fc-0cab-744e-9845-93f1fd7a6f97.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and white siding.",
        "public_id": "019e60fc-0cab-744e-9845-93f1fd7a6f97",
        "storage_key": "property/6767906449165577/019e60fc-0cab-744e-9845-93f1fd7a6f97.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "View of the exterior of a modern apartment building featuring white siding, dark brick accents, and private balconies.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and white siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05373ce8-610c-4eb8-80fe-09547786ad65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-9531-7097-85ed-8589310dd756.webp",
      "image_media": {
        "alt_text": "Lynx Gate City monument sign with building in background",
        "public_id": "019e60fa-9531-7097-85ed-8589310dd756",
        "storage_key": "property/6767906449165577/019e60fa-9531-7097-85ed-8589310dd756.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "Welcome to Lynx Gate City, a beautiful apartment community. Visit our website at lynxgatecity.com to learn more.",
      "link": "",
      "alt_text": "Lynx Gate City monument sign with building in background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d9ba662-3edf-4d51-8a9d-6fe92b9d298b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fc-048a-7006-b018-928547d25e75.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite vanity, black fixtures, and white bathtub and toilet.",
        "public_id": "019e60fc-048a-7006-b018-928547d25e75",
        "storage_key": "property/6767906449165577/019e60fc-048a-7006-b018-928547d25e75.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Updated bathroom featuring a granite countertop vanity with a modern black faucet, a clean white toilet, and a spacious white bathtub with black fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with granite vanity, black fixtures, and white bathtub and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de9a66fa-550e-4c2d-b2cc-2bb4ad614bb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fc-01ec-771d-8c78-d6d18c938376.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, light grey walls, and a doorway leading to a bathroom.",
        "public_id": "019e60fc-01ec-771d-8c78-d6d18c938376",
        "storage_key": "property/6767906449165577/019e60fc-01ec-771d-8c78-d6d18c938376.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, featuring a modern ceiling fan and soft carpeting. Enjoy natural light streaming through the blinds, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan, light grey walls, and a doorway leading to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bad28dc6-15da-47cf-baea-9c2fccc1816b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-f578-759d-9853-a0cecbae0cd8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite vanity, modern toilet, and white bathtub.",
        "public_id": "019e60fb-f578-759d-9853-a0cecbae0cd8",
        "storage_key": "property/6767906449165577/019e60fb-f578-759d-9853-a0cecbae0cd8.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Step into this contemporary bathroom featuring a stylish granite-topped vanity, a sleek toilet, and a pristine white bathtub, perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with granite vanity, modern toilet, and white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fcb2b89-7c82-4f39-9942-8570c1cc421e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-ee02-72af-aaee-2ccbfed77d7e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a white door, ceiling fan, and window.",
        "public_id": "019e60fb-ee02-72af-aaee-2ccbfed77d7e",
        "storage_key": "property/6767906449165577/019e60fb-ee02-72af-aaee-2ccbfed77d7e.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral grey walls, plush carpeting, a ceiling fan, and abundant natural light. Ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with a white door, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46112f86-29e7-44fa-9276-498b58b006be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-e40f-75aa-8540-fd730c293026.webp",
      "image_media": {
        "alt_text": "Empty bedroom with gray carpet, ceiling fan, and a window with blinds letting in sunlight.",
        "public_id": "019e60fb-e40f-75aa-8540-fd730c293026",
        "storage_key": "property/6767906449165577/019e60fb-e40f-75aa-8540-fd730c293026.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom featuring plush gray carpeting, a modern ceiling fan, and large windows that flood the space with natural light.",
      "link": "",
      "alt_text": "Empty bedroom with gray carpet, ceiling fan, and a window with blinds letting in sunlight.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e314de8-271a-444b-bc78-2f1bd77574bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-d6ef-746a-9e44-4f0587791755.webp",
      "image_media": {
        "alt_text": "Empty living room with gray walls, wood laminate flooring, and a window with blinds.",
        "public_id": "019e60fb-d6ef-746a-9e44-4f0587791755",
        "storage_key": "property/6767906449165577/019e60fb-d6ef-746a-9e44-4f0587791755.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral gray walls and modern wood laminate flooring, featuring a large window that lets in natural light.",
      "link": "",
      "alt_text": "Empty living room with gray walls, wood laminate flooring, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c0a25d6-a587-4ad8-ad77-e8b3999f0e7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-c90a-70d9-ab4a-5f4a67ef49e0.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a view into the kitchen.",
        "public_id": "019e60fb-c90a-70d9-ab4a-5f4a67ef49e0",
        "storage_key": "property/6767906449165577/019e60fb-c90a-70d9-ab4a-5f4a67ef49e0.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living area with light wood flooring, connecting seamlessly to a modern kitchen with ample counter space and appliances.",
      "link": "",
      "alt_text": "Bright and airy living room with a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_184669fa-353e-4497-a338-79343286ca10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-c78b-73e2-a580-8a43d46af52b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and blinds on the window.",
        "public_id": "019e60fb-c78b-73e2-a580-8a43d46af52b",
        "storage_key": "property/6767906449165577/019e60fb-c78b-73e2-a580-8a43d46af52b.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral paint, plush carpeting, and a ceiling fan for comfort. Natural light streams through the window blinds.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and blinds on the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49f8c499-5a12-40f8-8f7b-46c58442b1d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-c2b5-7649-b46d-b0eebec6b82c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e60fb-c2b5-7649-b46d-b0eebec6b82c",
        "storage_key": "property/6767906449165577/019e60fb-c2b5-7649-b46d-b0eebec6b82c.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Step into this sleek and modern kitchen, featuring crisp white cabinetry, elegant granite countertops, and a full suite of stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c4be5da-d2f1-4f0d-8c5a-421569c194a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-bce0-764c-9c4d-720dd48ed604.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019e60fb-bce0-764c-9c4d-720dd48ed604",
        "storage_key": "property/6767906449165577/019e60fb-bce0-764c-9c4d-720dd48ed604.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, ample cabinet space, and granite countertops. Perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2af122fd-8e80-4ec3-855a-0c0c130b3fe0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-b2ff-71c1-9102-becae65d337a.webp",
      "image_media": {
        "alt_text": "View of trees and street through a large window with white blinds.",
        "public_id": "019e60fb-b2ff-71c1-9102-becae65d337a",
        "storage_key": "property/6767906449165577/019e60fb-b2ff-71c1-9102-becae65d337a.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Bright and airy apartment living space featuring a large window with blinds that offers a view of the surrounding trees and street.",
      "link": "",
      "alt_text": "View of trees and street through a large window with white blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fe936b1-5c42-418a-8138-5b38c377694c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-b4c8-75e9-8968-f703c43e94d7.webp",
      "image_media": {
        "alt_text": "View of a modern apartment kitchen with white cabinets and a granite countertop.",
        "public_id": "019e60fb-b4c8-75e9-8968-f703c43e94d7",
        "storage_key": "property/6767906449165577/019e60fb-b4c8-75e9-8968-f703c43e94d7.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment kitchen, featuring sleek white cabinetry, a durable granite countertop, and modern fixtures. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "View of a modern apartment kitchen with white cabinets and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ae0a834-31f6-4912-b5fb-f56e3d1d5b42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-b252-7168-b4e4-416216264617.webp",
      "image_media": {
        "alt_text": "Bedroom with neutral gray walls, carpet, a ceiling fan, and a large window with blinds.",
        "public_id": "019e60fb-b252-7168-b4e4-416216264617",
        "storage_key": "property/6767906449165577/019e60fb-b252-7168-b4e4-416216264617.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "This spacious bedroom features plush carpeting, a modern ceiling fan, and ample natural light from a large window with blinds.",
      "link": "",
      "alt_text": "Bedroom with neutral gray walls, carpet, a ceiling fan, and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ad9defc-0517-4b83-aebd-95621313cef7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-9eee-77cc-96dd-f67662773aa4.webp",
      "image_media": {
        "alt_text": "Empty living room with large windows overlooking trees.",
        "public_id": "019e60fb-9eee-77cc-96dd-f67662773aa4",
        "storage_key": "property/6767906449165577/019e60fb-9eee-77cc-96dd-f67662773aa4.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral gray walls and wood-look flooring, featuring a large window with blinds for natural light.",
      "link": "",
      "alt_text": "Empty living room with large windows overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7acc20a4-9395-4e92-b8d6-c04cdc6815bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-9122-75ff-be98-70626296aea8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an open view to the living area.",
        "public_id": "019e60fb-9122-75ff-be98-70626296aea8",
        "storage_key": "property/6767906449165577/019e60fb-9122-75ff-be98-70626296aea8.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Discover the spacious and modern kitchen in our apartments, featuring sleek white cabinetry, elegant granite countertops, and high-quality stainless steel appliances. Enjoy an open layout that seamlessly connects to your living space.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an open view to the living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_802b4eff-df94-4f9c-b912-4cdcb2edff31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-77f9-7024-ae6c-a59ada2ca170.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e60fb-77f9-7024-ae6c-a59ada2ca170",
        "storage_key": "property/6767906449165577/019e60fb-77f9-7024-ae6c-a59ada2ca170.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space, flowing into a dining area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77788e1c-f4f3-4ec9-ba80-2addff9192c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-753e-73f9-b6a4-da04da4e7a6f.webp",
      "image_media": {
        "alt_text": "Living room with ceiling fan and access to balcony.",
        "public_id": "019e60fb-753e-73f9-b6a4-da04da4e7a6f",
        "storage_key": "property/6767906449165577/019e60fb-753e-73f9-b6a4-da04da4e7a6f.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living area with a ceiling fan, blinds on windows, and a door leading to a balcony. This room offers a comfortable and modern space for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with ceiling fan and access to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd927fcf-834a-4374-a1a9-43ebf73d01b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-762c-735c-8868-a8887f55fa26.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e60fb-762c-735c-8868-a8887f55fa26",
        "storage_key": "property/6767906449165577/019e60fb-762c-735c-8868-a8887f55fa26.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Discover a stylish and functional kitchen, perfect for everyday cooking and entertaining. Features white cabinetry, sleek granite countertops, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6d319ff-b299-44db-a577-f6bdd32f7008",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-711f-767a-82f5-dac11fe57ea0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e60fb-711f-767a-82f5-dac11fe57ea0",
        "storage_key": "property/6767906449165577/019e60fb-711f-767a-82f5-dac11fe57ea0.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_649507e6-d92a-45b6-bec0-86121572489e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-5cfe-7106-a840-162080a60985.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub/shower combo.",
        "public_id": "019e60fb-5cfe-7106-a840-162080a60985",
        "storage_key": "property/6767906449165577/019e60fb-5cfe-7106-a840-162080a60985.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a granite-top vanity, a deep soaking tub with shower, and ample shelving for storage.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02f00bda-9a8f-4404-bd0d-baa5c4158a73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-5b55-76fc-bab6-7e7aed68eddf.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and doors leading to a bathroom and closet.",
        "public_id": "019e60fb-5b55-76fc-bab6-7e7aed68eddf",
        "storage_key": "property/6767906449165577/019e60fb-5b55-76fc-bab6-7e7aed68eddf.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a ceiling fan, plush carpeting, and convenient access to an ensuite bathroom and closet, offering a comfortable living space.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and doors leading to a bathroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da0f2dfe-d908-4e75-a3b4-30810b8eb1bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-5803-712e-b21e-57bf0bcb6bf0.webp",
      "image_media": {
        "alt_text": "Bedroom with neutral gray walls, carpet, ceiling fan, and blinds.",
        "public_id": "019e60fb-5803-712e-b21e-57bf0bcb6bf0",
        "storage_key": "property/6767906449165577/019e60fb-5803-712e-b21e-57bf0bcb6bf0.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring neutral gray walls, plush carpeting, a modern ceiling fan, and large windows with blinds for natural light.",
      "link": "",
      "alt_text": "Bedroom with neutral gray walls, carpet, ceiling fan, and blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7118de27-62f2-493f-a6f1-df90d9d4745b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-538a-711c-ae99-b6b8ddc72f6a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, vanity, and black fixtures.",
        "public_id": "019e60fb-538a-711c-ae99-b6b8ddc72f6a",
        "storage_key": "property/6767906449165577/019e60fb-538a-711c-ae99-b6b8ddc72f6a.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Step into this beautifully renovated bathroom, featuring a sleek white tub and shower combo, a modern vanity with granite countertops, and elegant black fixtures throughout. Perfect for relaxing after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, vanity, and black fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4e4674e-d7b5-4db9-85c8-9ddfb9ae96db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-4dfd-75f9-b53d-e9fa511559aa.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and closet doors",
        "public_id": "019e60fb-4dfd-75f9-b53d-e9fa511559aa",
        "storage_key": "property/6767906449165577/019e60fb-4dfd-75f9-b53d-e9fa511559aa.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan, and ample closet space. Access to an en-suite bathroom is visible.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and closet doors",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0349cec-c73c-4af5-810d-5ce15425d2d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-4bfa-7348-ab85-3d4b1cded8ef.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with a white tub, toilet, and vanity with a granite countertop.",
        "public_id": "019e60fb-4bfa-7348-ab85-3d4b1cded8ef",
        "storage_key": "property/6767906449165577/019e60fb-4bfa-7348-ab85-3d4b1cded8ef.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bathroom featuring a sleek bathtub, a modern toilet, and a stylish vanity with a granite countertop and a large rectangular mirror.",
      "link": "",
      "alt_text": "Clean and modern bathroom with a white tub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fa734442-ee73-4b84-9dcb-6783612ef392",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-3808-71ac-8661-aeeeec2fe9f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and access to bathrooms.",
        "public_id": "019e60fb-3808-71ac-8661-aeeeec2fe9f2",
        "storage_key": "property/6767906449165577/019e60fb-3808-71ac-8661-aeeeec2fe9f2.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a modern ceiling fan, and convenient access to en-suite bathrooms.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and access to bathrooms.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e9a562ca-ee65-4a9a-accb-05d07377dc26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-35a2-718b-9417-c52f92669c06.webp",
      "image_media": {
        "alt_text": "Bedroom with ensuite bathroom and a ceiling fan.",
        "public_id": "019e60fb-35a2-718b-9417-c52f92669c06",
        "storage_key": "property/6767906449165577/019e60fb-35a2-718b-9417-c52f92669c06.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and an attached bathroom, offering comfort and convenience.",
      "link": "",
      "alt_text": "Bedroom with ensuite bathroom and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b4a2f44-6dd7-4dd8-a32a-4c6ab024ab01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-2e52-72d3-b013-7da2615b7bc4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and blinds on the window.",
        "public_id": "019e60fb-2e52-72d3-b013-7da2615b7bc4",
        "storage_key": "property/6767906449165577/019e60fb-2e52-72d3-b013-7da2615b7bc4.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "This empty bedroom features a ceiling fan for comfort and large windows with blinds, offering natural light.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and blinds on the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19afe2eb-d500-4e69-932a-482d4f5ab089",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-3253-72f9-a66d-6c0cd4dc3dbe.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, ceiling fan, and blinds on the window.",
        "public_id": "019e60fb-3253-72f9-a66d-6c0cd4dc3dbe",
        "storage_key": "property/6767906449165577/019e60fb-3253-72f9-a66d-6c0cd4dc3dbe.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring neutral gray carpeting, a modern ceiling fan, and large blinds on the window for adjustable light.",
      "link": "",
      "alt_text": "Bedroom with carpet, ceiling fan, and blinds on the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65ac954d-5372-43f5-a127-a50ad3e78674",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-1d88-7128-8ea9-e18f2ce2abf8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a large window with blinds.",
        "public_id": "019e60fb-1d88-7128-8ea9-e18f2ce2abf8",
        "storage_key": "property/6767906449165577/019e60fb-1d88-7128-8ea9-e18f2ce2abf8.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom with plush carpeting and a modern ceiling fan. Large windows with blinds allow natural light to fill the space.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52a5bd25-92a4-44f9-9e69-c531dd0066a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-1348-736f-8f38-23858dfe0deb.webp",
      "image_media": {
        "alt_text": "Bedroom with a white door, ceiling fan, and window with blinds.",
        "public_id": "019e60fb-1348-736f-8f38-23858dfe0deb",
        "storage_key": "property/6767906449165577/019e60fb-1348-736f-8f38-23858dfe0deb.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a white door, a modern ceiling fan, and a large window with blinds, offering a comfortable and inviting living space.",
      "link": "",
      "alt_text": "Bedroom with a white door, ceiling fan, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc572b36-5b89-4095-9499-e896c1c31156",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-1466-768d-8408-1930c24119ba.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with white bathtub, toilet, and vanity with granite countertop.",
        "public_id": "019e60fb-1466-768d-8408-1930c24119ba",
        "storage_key": "property/6767906449165577/019e60fb-1466-768d-8408-1930c24119ba.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this well-appointed bathroom, featuring a sleek white bathtub, a modern toilet, and a vanity with a beautiful granite countertop and black fixtures.",
      "link": "",
      "alt_text": "Clean and modern bathroom with white bathtub, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f64c00de-f788-49a4-bd64-84bbfc85130f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fb-03a3-7490-b30d-b8b128fffe24.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet, a ceiling fan, and a large window with blinds.",
        "public_id": "019e60fb-03a3-7490-b30d-b8b128fffe24",
        "storage_key": "property/6767906449165577/019e60fb-03a3-7490-b30d-b8b128fffe24.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features soft neutral carpeting, a modern ceiling fan, and a large window providing ample natural light.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet, a ceiling fan, and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_00051b36-8ab5-4671-92b9-904db3f83ce8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-fffb-74d8-8801-70b1f9a26efe.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and a window.",
        "public_id": "019e60fa-fffb-74d8-8801-70b1f9a26efe",
        "storage_key": "property/6767906449165577/019e60fa-fffb-74d8-8801-70b1f9a26efe.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a modern ceiling fan, and a large window with blinds. Includes access to an additional room and hallway.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e1ff2b3f-70bc-4859-8240-1c890c08a7bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-fb14-730e-92cb-f0ffe784645f.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and doors to bathroom and closet",
        "public_id": "019e60fa-fb14-730e-92cb-f0ffe784645f",
        "storage_key": "property/6767906449165577/019e60fa-fb14-730e-92cb-f0ffe784645f.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern ceiling fan and access to a well-appointed bathroom. Offers ample closet space for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and doors to bathroom and closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0597230b-1659-4242-8873-8e90c5e24115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-edc2-7035-acd1-bb7a985073e8.webp",
      "image_media": {
        "alt_text": "Empty apartment room with a large window covered by blinds.",
        "public_id": "019e60fa-edc2-7035-acd1-bb7a985073e8",
        "storage_key": "property/6767906449165577/019e60fa-edc2-7035-acd1-bb7a985073e8.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious and light-filled apartment room, perfect for personalizing your living space. Features a large window with blinds for privacy and light control.",
      "link": "",
      "alt_text": "Empty apartment room with a large window covered by blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f295a106-9077-428b-b32c-76fad41888be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-e682-71cf-aaae-c917dac68b29.webp",
      "image_media": {
        "alt_text": "Bedroom with plush carpet and a ceiling fan",
        "public_id": "019e60fa-e682-71cf-aaae-c917dac68b29",
        "storage_key": "property/6767906449165577/019e60fa-e682-71cf-aaae-c917dac68b29.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and a large window with blinds. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Bedroom with plush carpet and a ceiling fan",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_085e5924-fd10-46ad-be50-c291b0a09866",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-deee-773d-9987-d59a4cc99376.webp",
      "image_media": {
        "alt_text": "Living room with wood-look flooring and a ceiling fan",
        "public_id": "019e60fa-deee-773d-9987-d59a4cc99376",
        "storage_key": "property/6767906449165577/019e60fa-deee-773d-9987-d59a4cc99376.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living room featuring wood-look flooring, a ceiling fan, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room with wood-look flooring and a ceiling fan",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_151b3198-d8f6-4e16-b784-fab7939ee960",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-df8d-702f-ac19-8b1eeda06d6d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e60fa-df8d-702f-ac19-8b1eeda06d6d",
        "storage_key": "property/6767906449165577/019e60fa-df8d-702f-ac19-8b1eeda06d6d.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring white cabinetry, granite countertops, a stainless steel refrigerator, range, and microwave.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45fc4896-17a8-476b-9f65-70ff6c57c0eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-d3e5-760e-a634-84095bde4aa6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub.",
        "public_id": "019e60fa-d3e5-760e-a634-84095bde4aa6",
        "storage_key": "property/6767906449165577/019e60fa-d3e5-760e-a634-84095bde4aa6.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a large mirror, a toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f18c8ea0-e069-4087-98a6-0e2cf9c0127a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-d320-7452-af70-da896c31ac45.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019e60fa-d320-7452-af70-da896c31ac45",
        "storage_key": "property/6767906449165577/019e60fa-d320-7452-af70-da896c31ac45.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek granite countertops, stainless steel appliances, and abundant storage for your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b870d7e2-c5a0-44b4-90c5-7c009c0ccb17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-8c40-74b9-bd99-146fde5bde56.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019e60fa-8c40-74b9-bd99-146fde5bde56",
        "storage_key": "property/6767906449165577/019e60fa-8c40-74b9-bd99-146fde5bde56.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, white shaker cabinets, and granite countertops, perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75f2e4f5-504f-44e7-b63d-e1e9db6087ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-8294-73e3-bb43-2fdc82abc1d7.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, punching bag, and free weights.",
        "public_id": "019e60fa-8294-73e3-bb43-2fdc82abc1d7",
        "storage_key": "property/6767906449165577/019e60fa-8294-73e3-bb43-2fdc82abc1d7.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, and a dedicated space for functional training.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, punching bag, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfd6d5f3-109d-40bb-890b-9898dad9ae07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-8343-71f9-a395-2c9d1e3669bf.webp",
      "image_media": {
        "alt_text": "Dumbbells on a rack in a fitness center.",
        "public_id": "019e60fa-8343-71f9-a395-2c9d1e3669bf",
        "storage_key": "property/6767906449165577/019e60fa-8343-71f9-a395-2c9d1e3669bf.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Get your workout in at our fully-equipped fitness center. Featuring a variety of weights and cardio machines for residents.",
      "link": "",
      "alt_text": "Dumbbells on a rack in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8eb83fdc-a439-48c1-a9f4-ea3680424a1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-8358-720c-9e46-c1a0ed182659.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, free weights, and exercise balls.",
        "public_id": "019e60fa-8358-720c-9e46-c1a0ed182659",
        "storage_key": "property/6767906449165577/019e60fa-8358-720c-9e46-c1a0ed182659.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight machines, free weights, and cardio equipment. Perfect for your wellness routine.",
      "link": "",
      "alt_text": "Gym with weight machines, free weights, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2f50246-243c-45c8-b1d5-1801fcb400b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-7873-7634-a21b-427c449472fe.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and punching bag.",
        "public_id": "019e60fa-7873-7634-a21b-427c449472fe",
        "storage_key": "property/6767906449165577/019e60fa-7873-7634-a21b-427c449472fe.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and a boxing area.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3adc5dc2-a281-4c6f-ba2a-44f5ad3030a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e60fa-3d89-76f5-aa0a-807276c0d441.webp",
      "image_media": {
        "alt_text": "Dumbbells on a rack in a gym.",
        "public_id": "019e60fa-3d89-76f5-aa0a-807276c0d441",
        "storage_key": "property/6767906449165577/019e60fa-3d89-76f5-aa0a-807276c0d441.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Workout with a full set of dumbbells available in our on-site fitness center. Perfect for strength training and achieving your fitness goals.",
      "link": "",
      "alt_text": "Dumbbells on a rack in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4151918b-ae94-4907-9582-2ee5b8519ea5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Four Seasons Town Centre",
      "poi_type": "Shopping & Retail",
      "poi_address": "410 Four Seasons Town Centre, Greensboro, NC 27407, USA",
      "poi_short_description": "3-story indoor mall with dozens of popular chain stores, a food court & a bowling/amusement center.",
      "poi_long_description": "People say this mall features a wide variety of stores across three floors, including major department stores and unique vendors. They also highlight the ample parking, clean environment, and family-friendly atmosphere.\n\nSome reviews mention the escalators can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2530-75c2-b106-d7df2dbe5892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2530-75c2-b106-d7df2dbe5892",
        "storage_key": "property/6767906449165577/019e1dd4-2530-75c2-b106-d7df2dbe5892.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shopfourseasons.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3464894790998458551&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-seasons-town-centre",
      "poi_latitude": "36.0393981",
      "poi_longitude": "-79.8379355",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 336-299-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc83-750b-9972-57616e47a71b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc83-750b-9972-57616e47a71b",
        "storage_key": "property/6767906449165577/019e1dd5-bc83-750b-9972-57616e47a71b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYxAk0y8aU4gRt4CQYXTHFTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d6d2ce56-a2e4-45a8-9fe5-0adb0108adbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3202 W Friendly Ave, Greensboro, NC 27408, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, including organic choices, and a well-stocked food bar with diverse options. They also highlight the friendly and helpful staff, clean environment, and convenient Amazon return service.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2586-7236-a9f1-e29a285290ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2586-7236-a9f1-e29a285290ee",
        "storage_key": "property/6767906449165577/019e1dd4-2586-7236-a9f1-e29a285290ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/greensborofriendly?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1587597156730394069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.0857454",
      "poi_longitude": "-79.8341387",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 336-398-2880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc82-71ad-811f-0b160a0ac379",
        "storage_key": "property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0I3o_4bU4gR1dVV3TNHCBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8b5fc77a-bed6-4e15-8add-bfb59cd35652",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Friendly Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3110 Kathleen Ave, Greensboro, NC 27408, USA",
      "poi_short_description": "Major fashion & technology retailers are joined by boutiques, dining options & grooming services.",
      "poi_long_description": "People say this shopping center offers a wide range of stores, restaurants, and a movie theater. They highlight the convenient parking, clean sidewalks and parking lots, and the outdoor entrances of all stores. They also like the exceptional landscaping and the fun, exciting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2c8a-737c-a0d4-9a8b975d8d6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2c8a-737c-a0d4-9a8b975d8d6d",
        "storage_key": "property/6767906449165577/019e1dd4-2c8a-737c-a0d4-9a8b975d8d6d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.friendlycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13258070045956672888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friendly-center",
      "poi_latitude": "36.0861268",
      "poi_longitude": "-79.8360041",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 336-299-9802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc83-750b-9972-57616e47a71b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc83-750b-9972-57616e47a71b",
        "storage_key": "property/6767906449165577/019e1dd5-bc83-750b-9972-57616e47a71b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8xkJ4fsbU4gReI1-aHYg_rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e71b05b9-f0f5-44a9-bcfc-57d049e5ec1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Super G Mart Greensboro",
      "poi_type": "Shopping & Retail",
      "poi_address": "4927 W Market St, Greensboro, NC 27407, USA",
      "poi_short_description": "Sprawling grocery store selling spices from various countries and fresh produce.",
      "poi_long_description": "This international grocery store is praised for its incredible selection of international foods, including fresh produce, meat, and seafood, with many unique and hard-to-find items. Visitors also appreciate the friendly staff and the convenience of having various smaller shops and restaurants inside.\n\nSome reviews mention the produce can be spoiled.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2b5f-77a9-a0a3-644a700e99be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2b5f-77a9-a0a3-644a700e99be",
        "storage_key": "property/6767906449165577/019e1dd4-2b5f-77a9-a0a3-644a700e99be.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "https://www.supergmart.com/gso",
      "poi_directions_map_url": "https://maps.google.com/?cid=12158702296831924100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "super-g-mart-greensboro",
      "poi_latitude": "36.0670227",
      "poi_longitude": "-79.87540229999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 336-252-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc82-71ad-811f-0b160a0ac379",
        "storage_key": "property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7zw7wkbU4gRhJdkxFFjvKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0dd2bd47-6ca1-4469-8796-a443d2d722af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Publix Super Market at Grandover Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "6029 W Gate City Blvd, Greensboro, NC 27407, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, deli meats, and baked goods, including custom cakes and sushi. They highlight the clean and well-organized store, and the friendly and helpful staff. They also like the convenient online ordering and catering services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2c43-777b-bdfd-0f5b4a40b5b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2c43-777b-bdfd-0f5b4a40b5b7",
        "storage_key": "property/6767906449165577/019e1dd4-2c43-777b-bdfd-0f5b4a40b5b7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1658&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16866838672267850090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-grandover-village",
      "poi_latitude": "36.0000457",
      "poi_longitude": "-79.9060058",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 336-894-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc82-71ad-811f-0b160a0ac379",
        "storage_key": "property/6767906449165577/019e1dd5-bc82-71ad-811f-0b160a0ac379.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM458sMoRU4gRarFYeGgME-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8d35df19-440d-4b44-843a-294a46291ba4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "North Carolina Agricultural and Technical State University",
      "poi_type": "Education",
      "poi_address": "1601 E Market St, Greensboro, NC 27411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-33f6-7598-ad4c-5df464e31603.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-33f6-7598-ad4c-5df464e31603",
        "storage_key": "property/6767906449165577/019e1dd4-33f6-7598-ad4c-5df464e31603.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ncat.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13709045284706618846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-carolina-agricultural-and-technical-state-university",
      "poi_latitude": "36.0770034",
      "poi_longitude": "-79.7718199",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 336-334-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc9a-7508-a9d8-5a2191b94e16",
        "storage_key": "property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRQt4BcwYU4gR3o2uhA1QQL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fd89800b-1f85-4274-b0ee-53d7d992d88f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "University of North Carolina Greensboro",
      "poi_type": "Education",
      "poi_address": "1400 Spring Garden St, Greensboro, NC 27412, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-53a7-77af-9ddc-5daab4d308a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-53a7-77af-9ddc-5daab4d308a4",
        "storage_key": "property/6767906449165577/019e1dd4-53a7-77af-9ddc-5daab4d308a4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.uncg.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11825176477995211687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-north-carolina-greensboro",
      "poi_latitude": "36.0689296",
      "poi_longitude": "-79.8101976",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 336-334-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc9a-7508-a9d8-5a2191b94e16",
        "storage_key": "property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl8BtURUZU4gRp5s1sVp3G6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0fe121ad-11f2-4292-b2cf-8258331cef76",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Greensboro College",
      "poi_type": "Education",
      "poi_address": "815 W Market St, Greensboro, NC 27401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-57df-766a-9fe0-540d6fbe2dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-57df-766a-9fe0-540d6fbe2dbf",
        "storage_key": "property/6767906449165577/019e1dd4-57df-766a-9fe0-540d6fbe2dbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greensboro.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16241366062272712797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greensboro-college",
      "poi_latitude": "36.0710001",
      "poi_longitude": "-79.8002632",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 336-272-7102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc9a-7508-a9d8-5a2191b94e16",
        "storage_key": "property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVTeCDwZU4gRXZDZGGLsZOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9144ea27-9596-4465-a542-810c6689f60e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Wet 'n Wild Emerald Pointe Water Park",
      "poi_type": "Entertainment",
      "poi_address": "3910 S Holden Rd, Greensboro, NC 27406, USA",
      "poi_short_description": "Water park with slides, steep water chutes & an 84-ft.-wide wave pool, plus cabanas & kids' areas.",
      "poi_long_description": "Visitors say this water park offers a wide variety of fun slides and attractions for all ages, with many highlighting the wave pool and lazy river. They also appreciate the attentive staff, clean facilities, and the value of season passes.\n\nSome reviews mention the park can be overcrowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-5e90-777b-b352-3dc3022acc36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-5e90-777b-b352-3dc3022acc36",
        "storage_key": "property/6767906449165577/019e1dd4-5e90-777b-b352-3dc3022acc36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://emeraldpointe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12014171617103758081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wet-n-wild-emerald-pointe-water-park",
      "poi_latitude": "36.0070516",
      "poi_longitude": "-79.83812929999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 336-852-9721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTU4sUwYaU4gRAcMMlG7puqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_baa8de18-65cd-430a-bf69-58f023fb0ae7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Greensboro Complex",
      "poi_type": "Entertainment",
      "poi_address": "1921 West Gate City Boulevard, Greensboro, NC 27403",
      "poi_short_description": "",
      "poi_long_description": "This arena is consistently praised by visitors as a great venue for various events, noting its plenty of seating and clean, well-maintained environment. Guests also appreciate the friendly staff and the convenient and ample parking available.\n\nSome reviews mention the parking can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-4de1-74b2-b3b2-278ab13681fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-4de1-74b2-b3b2-278ab13681fa",
        "storage_key": "property/6767906449165577/019e1dd4-4de1-74b2-b3b2-278ab13681fa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.greensborocoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615392456825722516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greensboro-complex",
      "poi_latitude": "36.054695",
      "poi_longitude": "-79.8250233",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 336-373-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVaDC2MZU4gRlFaN0i1Qigg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5ad23d4c-a40e-4f08-8469-b9a56409cdff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "ParTee Shack - Greensboro",
      "poi_type": "Entertainment",
      "poi_address": "3712 S Holden Rd, Greensboro, NC 27406, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this entertainment center offers unique and interactive mini golf courses and fast go-karts. They also highlight the reasonable prices for food and drinks, and the clean, well-maintained facility. Guests mention the staff are consistently friendly, helpful, and accommodating, enhancing the overall fun experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-5e94-770a-9bb2-717a627d1ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-5e94-770a-9bb2-717a627d1ee0",
        "storage_key": "property/6767906449165577/019e1dd4-5e94-770a-9bb2-717a627d1ee0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://parteeshack.com/greensboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=2936347525732196054&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "partee-shack---greensboro",
      "poi_latitude": "36.0082861",
      "poi_longitude": "-79.83842159999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 336-790-5392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4aIX-SkbU4gR1l5daIQAwCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7731708f-d537-4152-b8ee-e608e0fd42e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "High Point University",
      "poi_type": "Education",
      "poi_address": "1 N University Pkwy, High Point, NC 27262, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5b71-778f-81aa-f57d3cf3029b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5b71-778f-81aa-f57d3cf3029b",
        "storage_key": "property/6767906449165577/019e850f-5b71-778f-81aa-f57d3cf3029b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.highpoint.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9897603354053470244&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "high-point-university",
      "poi_latitude": "35.972171",
      "poi_longitude": "-79.9962549",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-841-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc9a-7508-a9d8-5a2191b94e16",
        "storage_key": "property/6767906449165577/019e1dd5-bc9a-7508-a9d8-5a2191b94e16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQTH0XtgOU4gRJGgSjs9ZW4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_df8112b3-9c66-4730-ab1e-05034274c99e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Topgolf Greensboro",
      "poi_type": "Entertainment",
      "poi_address": "609 Guilford College Rd, Greensboro, NC 27409, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Visitors say this American restaurant offers delicious chicken tenders, hot honey pepperoni flatbread, and a wide selection of drinks. They also highlight the friendly and attentive service, fun atmosphere, and affordable prices for the golf portion.\n\nSome reviews mention the wait times for food and drinks can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-2582-74dd-b4d1-08c1bfe362e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd4-2582-74dd-b4d1-08c1bfe362e9",
        "storage_key": "property/6767906449165577/019e1dd4-2582-74dd-b4d1-08c1bfe362e9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/greensboro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8271316605297333338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-greensboro",
      "poi_latitude": "36.064178",
      "poi_longitude": "-79.904918",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 743-249-3625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc8b-74b3-9f03-fb7843940991",
        "storage_key": "property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbzg7LMbU4gRWpSJE6GeyXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_63ef0c1b-d648-4b20-8d40-f211e1835509",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Celebration Station Greensboro",
      "poi_type": "Entertainment",
      "poi_address": "4315 Big Tree Way, Greensboro, NC 27409, USA",
      "poi_short_description": "Amusement park with bumper boats, arcade, mini-golf, go-karts & more as well as American eats.",
      "poi_long_description": "Visitors praise this entertainment center for its wide variety of activities, including go-karts, laser tag, and mini golf, alongside an arcade featuring many games. They also highlight the friendly staff, good food, and pizza.\n\nSome reviews mention the attractions can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5bdf-71ad-9e15-7e0b14786d8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5bdf-71ad-9e15-7e0b14786d8e",
        "storage_key": "property/6767906449165577/019e850f-5bdf-71ad-9e15-7e0b14786d8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.celebrationstation.com/greensboro-location/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=10141836427067993766&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "celebration-station-greensboro",
      "poi_latitude": "36.0582881",
      "poi_longitude": "-79.8931319",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-704-2316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7qhMBkbU4gRpi6BJX8Kv4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_24b433ac-5654-4111-9d10-c9c478c4200b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Greensboro Golf Courses",
      "poi_type": "Entertainment",
      "poi_address": "306 E Florida St, Greensboro, NC 27406, USA",
      "poi_short_description": "Public, 9- and 18-hole course with a driving range, plus a golf grill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5aca-7546-8d93-1e4073e7d0f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5aca-7546-8d93-1e4073e7d0f9",
        "storage_key": "property/6767906449165577/019e850f-5aca-7546-8d93-1e4073e7d0f9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.greensboro-nc.gov/departments/parks-recreation/golf-courses/gillespie-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=15047330636004045874&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gillespie-golf-course",
      "poi_latitude": "36.0481404",
      "poi_longitude": "-79.7836763",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-373-5850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-6af8-75cb-a6ea-715c5af70af9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e850f-6af8-75cb-a6ea-715c5af70af9",
        "storage_key": "property/6767906449165577/019e850f-6af8-75cb-a6ea-715c5af70af9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0p8_P0YU4gRMrTfQH3b0tA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5ed7fa23-09ea-4a7a-b689-a2062fcb1d55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Ninja Kidz Action Park (Previously Airbound)",
      "poi_type": "Entertainment",
      "poi_address": "4215 W Gate City Blvd, Greensboro, NC 27407, USA",
      "poi_short_description": "Amusement center offers 30,000 sq. ft. of trampolines space, plus a rock wall, arcade & more.",
      "poi_long_description": "Visitors say this amusement center provides a fun, active outing for kids' birthday parties, with exciting activities like trampoline basketball. They also highlight the friendly and helpful staff who ensure safety and make the experience enjoyable for all.\n\nSome reviews mention the pricing can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-614d-728b-aa04-606cd41560dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-614d-728b-aa04-606cd41560dc",
        "storage_key": "property/6767906449165577/019e850f-614d-728b-aa04-606cd41560dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ninjakidzparks.com/location-home/ninjakidz-108-greensboro",
      "poi_directions_map_url": "https://maps.google.com/?cid=6267961199773649959&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ninja-kidz-action-park-previously-airbound",
      "poi_latitude": "36.0344505",
      "poi_longitude": "-79.8634338",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-355-2835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-L5SlsaU4gRJ4xwioBF_FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_331f335b-596b-4244-8f14-d16433012531",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Comedy Zone",
      "poi_type": "Entertainment",
      "poi_address": "1126 S Holden Rd, Greensboro, NC 27407, USA",
      "poi_short_description": "Stand-up comedy club featuring well-known touring acts, plus drinks, eats & regular amateur nights.",
      "poi_long_description": "People say this comedy club offers hilarious comedians and delicious food, including tasty chicken wings and strong drinks. They also highlight the great atmosphere and the friendly, attentive staff who provide excellent service. Guests mention the clean restrooms and appreciate the intimate setting, where every seat feels close to the stage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5867-709f-8e1c-59a3e4c97884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5867-709f-8e1c-59a3e4c97884",
        "storage_key": "property/6767906449165577/019e850f-5867-709f-8e1c-59a3e4c97884.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://thecomedyzone.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8208271738871478812&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "comedy-zone",
      "poi_latitude": "36.0581135",
      "poi_longitude": "-79.8428481",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-333-1034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4KTjc8bU4gRHPpPP6ij6XE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "comedy_club"
    },
    {
      "id": "custom_b45c2d72-68c9-479e-8157-c5de1b1fd3c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "AMF All Star Lanes - Greensboro",
      "poi_type": "Entertainment",
      "poi_address": "910 S Holden Rd, Greensboro, NC 27407, USA",
      "poi_short_description": "Long-standing chain of bowling alleys featuring casual grub & pitchers, leagues & party events.",
      "poi_long_description": "People say this bowling alley offers a fun experience with plenty of lanes, a small snack bar serving good food, and a bar with drinks. They also highlight the reasonable prices, especially with Sunday specials, and the clean, family-friendly atmosphere.\n\nOther reviews mention the facilities can be dated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5ab9-76a5-8417-9be8cde9d0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5ab9-76a5-8417-9be8cde9d0d8",
        "storage_key": "property/6767906449165577/019e850f-5ab9-76a5-8417-9be8cde9d0d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amf.com/location/amf-all-star-lanes-nc/?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17832623841396083800&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amf-all-star-lanes---greensboro",
      "poi_latitude": "36.0603919",
      "poi_longitude": "-79.84383559999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-299-4432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJR-lpsUbU4gRWEyTB-c0evc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_47f5ce35-4b4c-4552-b2a9-a9195afc6543",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Weatherspoon Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1005 Spring Garden St, Greensboro, NC 27412, USA",
      "poi_short_description": "College museum offering a collection of 20th- & 21st-century American art plus exhibitions & events.",
      "poi_long_description": "Visitors say this art museum features a well-curated collection of contemporary art and interesting exhibits, including works by Carolina artists. They also highlight the free admission and convenient free parking. Guests mention the friendly and courteous staff, as well as the spotless restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5b32-74df-b001-c8decb331af8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5b32-74df-b001-c8decb331af8",
        "storage_key": "property/6767906449165577/019e850f-5b32-74df-b001-c8decb331af8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://weatherspoonart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17579749903077117002&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "weatherspoon-art-museum",
      "poi_latitude": "36.06610879999999",
      "poi_longitude": "-79.8060036",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-334-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-6af7-77af-b290-a3df308a5306.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e850f-6af7-77af-b290-a3df308a5306",
        "storage_key": "property/6767906449165577/019e850f-6af7-77af-b290-a3df308a5306.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxdQ3z8ZU4gRSoweNWXR9_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1aaca684-db3f-4ef0-b729-34f0f1f696be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Greensboro Science Center",
      "poi_type": "Entertainment",
      "poi_address": "4301 Lawndale Dr, Greensboro, NC 27455, USA",
      "poi_short_description": "Center boasting a 12-acre zoo, an aquarium & a hands-on museum plus a theatre with a 40-foot screen.",
      "poi_long_description": "People say this science museum offers a variety of attractions, including an aquarium, butterfly garden, carousel, dinosaur exhibit, outdoor zoo, and interactive exhibits. They highlight the family-friendly atmosphere, the educational and fun experiences, and the well-maintained animal enclosures. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-57ea-770b-95a8-c638ca336062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-57ea-770b-95a8-c638ca336062",
        "storage_key": "property/6767906449165577/019e850f-57ea-770b-95a8-c638ca336062.webp",
        "width": 1280,
        "height": 642
      },
      "poi_business_url": "http://www.greensboroscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9949249430626377330&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greensboro-science-center",
      "poi_latitude": "36.1296495",
      "poi_longitude": "-79.8334197",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-288-3769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc95-752e-85be-23eada47e60d",
        "storage_key": "property/6767906449165577/019e1dd5-bc95-752e-85be-23eada47e60d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_VL4iocU4gRch4-zqTVEoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_f770660e-4438-47d7-83ef-d40a99359169",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "1408 Four Seasons Sta Dr, Greensboro, NC 27407, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5e8d-732d-bd13-c1b1b0ef5efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5e8d-732d-bd13-c1b1b0ef5efe",
        "storage_key": "property/6767906449165577/019e850f-5e8d-732d-bd13-c1b1b0ef5efe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.whataburger.com/nc/greensboro/1408-four-seasons-station-drive.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=439762215286688307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "36.0411225",
      "poi_longitude": "-79.84374609999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-510-0932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc8b-74b3-9f03-fb7843940991",
        "storage_key": "property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOz36WQAbU4gRM0rNo2dZGgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_227bcff6-4e88-4ec0-b421-4363cd8ed24f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Smokey Bones Greensboro",
      "poi_type": "Restaurants",
      "poi_address": "3302 W Gate City Blvd, Greensboro, NC 27407, USA",
      "poi_short_description": "Smokehouse & barbecue dishes fill out the menu of this easygoing bar & grill chain.",
      "poi_long_description": "People say this restaurant serves delicious cheesy fries, grilled cheese with brisket, and ribs. They also highlight the great atmosphere and attentive service.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-5f60-758e-8ff2-9211191f035c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-5f60-758e-8ff2-9211191f035c",
        "storage_key": "property/6767906449165577/019e850f-5f60-758e-8ff2-9211191f035c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.smokeybones.com/nc/greensboro/3302-w-gate-city-blvd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10527823439143609667&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smokey-bones-greensboro",
      "poi_latitude": "36.0412255",
      "poi_longitude": "-79.8460974",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-315-8755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc8b-74b3-9f03-fb7843940991",
        "storage_key": "property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVzwSTEaU4gRQ6UvnKNXGpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_433b1899-831b-4079-883d-00e41c33f492",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "2100 Koury Blvd, Greensboro, NC 27407, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious Bang Bang Shrimp, salmon, and crab cakes, complemented by a wide variety of well-made drinks. The friendly, attentive, and knowledgeable staff are also frequently mentioned for creating a pleasant atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-6427-76ce-ab99-b5a12d5c0c6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-6427-76ce-ab99-b5a12d5c0c6b",
        "storage_key": "property/6767906449165577/019e850f-6427-76ce-ab99-b5a12d5c0c6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/north-carolina/greensboro/2100-koury-boulevard?y_source=1_MTU1MDI3ODAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12405827268858290512&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.0421385",
      "poi_longitude": "-79.8377689",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-851-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc8b-74b3-9f03-fb7843940991",
        "storage_key": "property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4upgS4aU4gRUCEnESxaKqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_fb38a52f-6ca3-419b-8398-59ed081a37f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "1400 Four Seasons Sta Dr, Greensboro, NC 27407, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this cafe has a great layout perfect for coffee dates or small meetings, offers delicious matcha and iced lemon loaf, and has a bright atmosphere with wonderful staff.\n\nOther reviews mention service can be slow and drinks can be made incorrectly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-63b8-70f8-b0d6-82395685f6d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-63b8-70f8-b0d6-82395685f6d4",
        "storage_key": "property/6767906449165577/019e850f-63b8-70f8-b0d6-82395685f6d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator?map=35.936365,-79.85052,10z&place=1400%20Four%20Seasons%20Station%20Drive,%20Greensboro,%20NC%2027407",
      "poi_directions_map_url": "https://maps.google.com/?cid=3718180188336333702&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "36.0417194",
      "poi_longitude": "-79.842956",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 743-258-6721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-6af5-766d-9798-ab29f7752f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e850f-6af5-766d-9798-ab29f7752f56",
        "storage_key": "property/6767906449165577/019e850f-6af5-766d-9798-ab29f7752f56.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJnw2idgAbU4gRhqOueC6hmTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_3098769e-37ac-48bc-9d52-feb5d1dcdde8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2710 Koury Blvd, Greensboro, NC 27407, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Reviewers consistently praise this fast-food restaurant for its delicious chicken sandwiches, nuggets, and waffle fries, complemented by their great lemonade. Customers also appreciate the friendly and attentive staff.\n\nSome reviews mention there can be lengthy wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e850f-630d-75ba-a4b0-1213076b1995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e850f-630d-75ba-a4b0-1213076b1995",
        "storage_key": "property/6767906449165577/019e850f-630d-75ba-a4b0-1213076b1995.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/gate-city?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6253735056309244408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.0408802",
      "poi_longitude": "-79.8443352",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 336-299-4643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd5-bc8b-74b3-9f03-fb7843940991",
        "storage_key": "property/6767906449165577/019e1dd5-bc8b-74b3-9f03-fb7843940991.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOarVDzEaU4gR-FG4Zua6yVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9fbd5ace-9c39-4be0-8d40-37b8e9af6fe8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fc3de5bf-5b65-48e7-829e-93c816a2d641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_691dace0-2c5d-4c7f-adf8-b7e0f0636b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_78faac3d-75da-4160-846d-fc7ca394ac20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5e60b356-ac14-4b74-bc02-c7383c176b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ab257bb6-09e7-4ecb-bbe7-d1c791ab30e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f232b3b6-f48b-42af-bfd4-b64e60911bde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "rating": "5",
      "name": "Dominic Brandveen",
      "text": "I just toured and i’m so thankful for Amy! She showed us around the beautiful property, told us about the new management upgrades, and sold us on what is (fingers crossed) our future home! The property is amazing, but the people in the office are truly the cornerstone of this little haven of luxury. I especially enjoy that they have employed people with 10+ years of experience in the field that know EXACTLY what they’re doing. Thank you Amy! I’ll be asking for you! :)",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_ee1d96bc-d4ac-41e3-882e-3a5eb584c094",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "rating": "5",
      "name": "Breanna Dickerson",
      "text": "I’m thrilled to share that I’ve been approved! This is an exciting new chapter in my life, and I want to express my deepest gratitude to the Lynx Team for their unwavering support. To Amy, your exceptional service has been truly remarkable. Your friendly demeanor, efficiency, and prompt assistance have made a significant difference in my experience. I also want to extend my heartfelt thanks to the management team for going above and beyond my expectations. They played a crucial role in helping me find the perfect apartment that met my needs. Thank you for your support as you continue to assist and provide solutions for our community.",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_f6dd0a60-d547-4aa0-9235-2bc185ac691c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "rating": "4",
      "name": "Tyrina Hinkle",
      "text": "We recently toured Lynx Gate City Apartments and had a great experience. The property is newly renovated, and the 1-bedroom units are very spacious with a clean, modern feel. Darryl was especially impressive, he was knowledgeable, professional, and extremely helpful in answering all of our questions. Overall, it was a welcoming and positive visit, and we would definitely recommend checking it out!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_6ddc7504-2afb-4c39-9ebf-20bd553831b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "rating": "5",
      "name": "T. Vega",
      "text": "FINALLY a person in the office who answered all of our questions about rent and our maintenance issues. She accepted our rental payment explained that they are working on the scanner issue and then she ask if everything was OK in our apartment! She did say that she was helping out until they are fully staffed, her name was Marcie…I think. A day later she called to see if our maintenance request was done to our satisfaction. That has never been done since I have been here, a follow up call on maintenance work orders.\nThere is still a problem with trash around the property, shopping carts left on the grounds and trash in the breezeways.",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_bb860e4e-e32d-4d47-a8e4-104e2f7b6c9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "rating": "5",
      "name": "Tanna Woods",
      "text": "Nevaeh was extremely nice and very helpful",
      "date": "2026-01-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_61681b39-5567-42fe-9539-1f0106762878",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-4d82-701f-aa10-e615fe8e2df2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-4d82-701f-aa10-e615fe8e2df2",
        "storage_key": "property/6767906449165577/019e1dd4-4d82-701f-aa10-e615fe8e2df2.webp",
        "width": 300,
        "height": 168
      },
      "virtual_tour_title": "A4 - CU (Cypress)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5126"
    },
    {
      "id": "custom_b0b9950a-2e11-418d-b8fe-5923dce45f22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e1dd4-5039-76df-8fa0-15138bcffffc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-5039-76df-8fa0-15138bcffffc",
        "storage_key": "property/6767906449165577/019e1dd4-5039-76df-8fa0-15138bcffffc.webp",
        "width": 300,
        "height": 168
      },
      "virtual_tour_title": "B4 - PU (Pine)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5127"
    },
    {
      "id": "custom_91ead5a9-5814-42c7-9905-d310912d27c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e4270-148b-73d2-a700-357066ed6a72.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4270-148b-73d2-a700-357066ed6a72",
        "storage_key": "property/6767906449165577/019e4270-148b-73d2-a700-357066ed6a72.webp",
        "width": 300,
        "height": 178
      },
      "virtual_tour_title": "A2-JRR",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5309"
    },
    {
      "id": "custom_2ba7d1dc-d0de-4c95-a1a8-e77b45e47b7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e4270-5ba6-769e-8bda-16ec4c6ffdb9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4270-5ba6-769e-8bda-16ec4c6ffdb9",
        "storage_key": "property/6767906449165577/019e4270-5ba6-769e-8bda-16ec4c6ffdb9.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "B3-ERR",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5310"
    },
    {
      "id": "custom_d1bb77df-1d34-4bed-9a91-cb8265d12524",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e4270-99af-700f-93e4-f83ac60050b2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4270-99af-700f-93e4-f83ac60050b2",
        "storage_key": "property/6767906449165577/019e4270-99af-700f-93e4-f83ac60050b2.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "B4-PRR",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5311"
    },
    {
      "id": "custom_ff042ac5-f25d-4254-bbb1-8b831d71723e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019e4271-0ee4-766f-a993-82bd17309ee7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4271-0ee4-766f-a993-82bd17309ee7",
        "storage_key": "property/6767906449165577/019e4271-0ee4-766f-a993-82bd17309ee7.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "B5-WRR",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=5312"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-ec5c-7150-8575-3c1349565c4c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-park-at-aventino",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577"
    },
    {
      "lead_collector_id": "0198aa47-ecbd-73f5-adec-9a1a02e2b757",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-park-at-aventino",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577"
    },
    {
      "lead_collector_id": "0198aa47-ed1f-777d-8312-1d96247a2039",
      "lead_source": "LANDING_PAGE",
      "name": "the-park-at-aventino",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "apartments-with-pool-greensboro-nc",
      "search_query": "apartments with pool in Greensboro NC",
      "category": "Amenity",
      "h1_title": "Discover Apartments with Pool in Greensboro, NC",
      "h2_subtitle": "Enjoy a refreshing lifestyle at The Park at Aventino. Our Greensboro location offers top-tier apartment living with a sparkling pool just steps away.",
      "page_copy": "Welcome to The Park at Aventino, where our community not only boasts modern conveniences but also a captivating outdoor pool. Dive into leisure right in the heart of Greensboro, NC. Whether you prefer a leisurely swim or lounging by the water's edge, our sparkling pool area perfectly complements the vibrant lifestyle here.\n\nNestled in Greensboro, these apartments with pool access extend beyond ordinary living. Reside in comfort with thoughtfully designed one and two-bedroom layouts, while enjoying the amenities like our state-of-the-art fitness center and tranquil walking trails. Embrace community living with us – poolside bliss awaits!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments with Pool",
      "seo_description": "Explore The Park at Aventino in Greensboro, NC. Modern apartments with a refreshing pool and more amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "greensboro-nc-apartments-with-fitness-center",
      "search_query": "Greensboro NC apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Top Greensboro NC Apartments with Fitness Center",
      "h2_subtitle": "Elevate your lifestyle at The Park at Aventino in Greensboro. Our apartments offer unbeatable access to a state-of-the-art fitness center.",
      "page_copy": "Discover the perfect blend of comfort and wellness at The Park at Aventino in Greensboro. Our apartments feature a fully-equipped fitness center, offering residents top-notch workout facilities. Stay motivated and achieve your fitness goals with our modern equipment, all conveniently located within steps of your home.\n\nOur Greensboro, NC apartments with a fitness center cater to those seeking an active lifestyle without compromising on comfort. Beyond the gym, experience the luxury of spacious one and two-bedroom homes, complemented by amenities like walking trails and a captivating pool. Live the life you aspire, with all the fitness resources you need at The Park at Aventino.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Greensboro NC Apartments with Fitness Center",
      "seo_description": "Find Greensboro NC apartments with a fitness center at The Park at Aventino. Enjoy modern facilities and engage in a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "apartments-with-walk-in-closets-guilford-county",
      "search_query": "apartments with walk-in closets Guilford County",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Walk-In Closets in Guilford County",
      "h2_subtitle": "Experience ample storage with The Park at Aventino's spacious layouts. Our Guilford County apartments feature luxurious walk-in closets for all your needs.",
      "page_copy": "The Park at Aventino in Guilford County redefines spacious living with our apartments that boast luxurious walk-in closets. These thoughtfully designed spaces ensure that all your belongings have a dedicated home, keeping your living area clutter-free and organized.\n\nSituated in the heart of Guilford County, our one and two-bedroom apartments offer more than just generous storage. Enjoy a range of amenities including a sparkling pool, state-of-the-art fitness center, and inviting walking trails. With a focus on comfort and convenience, The Park at Aventino provides a perfect backdrop for your vibrant lifestyle. Schedule a visit and see how our walk-in closets can transform your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments with Walk-In Closets",
      "seo_description": "Explore The Park at Aventino for Guilford County apartments with walk-in closets. Stylish living with ample storage awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-27407",
      "search_query": "air conditioned apartments near 27407",
      "category": "Amenity",
      "h1_title": "Comfortable Air Conditioned Apartments Near 27407",
      "h2_subtitle": "Stay cool at The Park at Aventino. Located near 27407, our apartments offer modern air conditioning for your comfort and convenience.",
      "page_copy": "Beat the heat with The Park at Aventino, offering luxurious air conditioned apartments near the 27407 area. Our modern air conditioning systems ensure that you stay comfortable all year round, providing a cool haven during those warm North Carolina summers.\n\nNestled conveniently near the 27407 zip code, our spacious one and two-bedroom homes offer more than just a climate-controlled environment. Revel in amenities such as a sparkling pool, a cutting-edge fitness center, and relaxing walking trails. Experience a lifestyle of utter comfort and ease - tour The Park at Aventino today and discover the sanctuary you've been seeking.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Air Conditioned Apartments Near 27407",
      "seo_description": "Discover air conditioned apartments near 27407 at The Park at Aventino. Enjoy comfort, modern amenities, and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-in-greensboro-nc",
      "search_query": "apartments with dishwasher in Greensboro NC",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwasher in Greensboro NC",
      "h2_subtitle": "Enjoy ultimate convenience at The Park at Aventino. Our Greensboro NC apartments come equipped with modern dishwashers for easy living.",
      "page_copy": "Simplify your daily routine by choosing The Park at Aventino, where each apartment includes a modern dishwasher. Located in Greensboro, NC, our one and two-bedroom apartments are designed to offer you convenience, making everyday tasks effortlessly manageable.\n\nBeyond modern kitchen appliances, residents of The Park at Aventino enjoy a host of other amenities including a sparkling pool, a state-of-the-art fitness center, and scenic walking trails. Experience a blend of luxury and practicality with our thoughtfully designed spaces, providing all the comforts of home in a vibrant Greensboro community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments with Dishwasher in Greensboro NC",
      "seo_description": "Find Greensboro NC apartments with a dishwasher at The Park at Aventino. Experience modern convenience in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-greensboro-nc",
      "search_query": "one bedroom apartments Greensboro NC",
      "category": "Floorplan",
      "h1_title": "Stylish One Bedroom Apartments in Greensboro NC",
      "h2_subtitle": "Discover the perfect one bedroom apartment at The Park at Aventino. Located in Greensboro NC, we offer ideal living spaces.",
      "page_copy": "The Park at Aventino invites you to explore our stylish one bedroom apartments situated in the heart of Greensboro, NC. These spaces are thoughtfully designed to combine comfort and functionality, creating a welcoming home environment.\n\nOur community in Greensboro not only offers beautifully crafted one-bedroom apartments but also an array of amenities including a refreshing pool, a cutting-edge fitness center, and serene walking trails. Discover the convenience of living in a vibrant community where everything you need is within reach. Schedule a tour today to find your perfect one-bedroom retreat at The Park at Aventino.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | One Bedroom Apartments Greensboro NC",
      "seo_description": "Explore one bedroom apartments in Greensboro NC at The Park at Aventino. Enjoy modern living with fantastic amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-guilford-county",
      "search_query": "two bedroom apartments Guilford County",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedroom Apartments in Guilford County",
      "h2_subtitle": "Find your ideal two bedroom apartment at The Park at Aventino. Located in Guilford County, enjoy space and comfort.",
      "page_copy": "Explore the generously sized two bedroom apartments available at The Park at Aventino, located conveniently in Guilford County. Our two-bedroom homes are perfect for those seeking extra space without compromising on style or comfort.\n\nNestled in a vibrant community, our apartments provide access to desirable amenities such as a sparkling pool, state-of-the-art fitness center, and scenic walking trails. Experience the lifestyle you deserve in a welcoming environment. Discover the charm of Guilford County living by making The Park at Aventino your next home with our spacious two-bedroom options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Two Bedroom Apartments Guilford County",
      "seo_description": "Discover spacious two bedroom apartments in Guilford County at The Park at Aventino, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "apartments-near-north-carolina-at-state-university-greensboro",
      "search_query": "apartments near north carolina a&t state university greensboro",
      "category": "School",
      "h1_title": "Convenient Apartments Near North Carolina A&T State University",
      "h2_subtitle": "Discover convenience and comfort with apartments near North Carolina A&T State University at The Park at Aventino in Greensboro.",
      "page_copy": "Located just a short distance from North Carolina A&T State University, The Park at Aventino offers the perfect base for students and professionals alike. Our modern apartments provide a convenient lifestyle within easy reach of campus, making it simple to balance work, study, and leisure.\n\nEnjoy spacious floor plans in a vibrant Greensboro community featuring exceptional amenities like a refreshing pool, a fully equipped fitness center, and scenic walking trails. The Park at Aventino provides not just a place to live, but a place that feels like home, located within a short commute to the university and the city's vibrant cultural offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments Near North Carolina A&T State University",
      "seo_description": "Find convenient apartments near North Carolina A&T State University in Greensboro at The Park at Aventino. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "guilford-county-apartments-near-guilford-college",
      "search_query": "guilford county apartments near guilford college",
      "category": "School",
      "h1_title": "Guilford County Apartments Near Guilford College",
      "h2_subtitle": "Experience student-friendly living at The Park at Aventino. Our apartments in Guilford County are perfectly situated near Guilford College.",
      "page_copy": "The Park at Aventino offers the perfect blend of convenience and comfort with our apartments located near Guilford College in Guilford County. Just a short drive from campus, enjoy easy access to educational pursuits while living amidst desirable amenities and a friendly community.\n\nOur community features inviting one and two-bedroom floor plans enhanced by amenities like a sparkling pool, state-of-the-art fitness center, and inviting walking trails. Whether you're a student or simply looking for a vibrant, well-connected place to live, The Park at Aventino is the ideal choice for you. Discover the perfect home base that's both close to college life and the welcoming charm of Guilford County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments Near Guilford College, Guilford County",
      "seo_description": "Discover Guilford County apartments near Guilford College at The Park at Aventino, offering spacious living with superior amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "apartments-near-our-childrens-house-elementary-school-27407",
      "search_query": "apartments near our children's house elementary school 27407",
      "category": "School",
      "h1_title": "Family-Friendly Apartments Near Our Children's House Elementary School",
      "h2_subtitle": "Live near Our Children's House Elementary School in the 27407 area. Discover family-friendly living at The Park at Aventino.",
      "page_copy": "Welcome to The Park at Aventino, a community offering family-friendly apartments just minutes from Our Children's House Elementary School in the 27407 zip code. This prime location offers parents and children the ease of a short commute, allowing more time to enjoy all that our vibrant community and Greensboro have to offer.\n\nEnjoy the comfort of spacious one and two-bedroom floor plans equipped with modern amenities, including a sparkling pool, fitness center, and walking trails. At The Park at Aventino, you’ll find the perfect blend of convenience, comfort, and community, making it an ideal choice for families prioritizing a nurturing school environment nearby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Apartments Near Our Children's House Elementary School",
      "seo_description": "Find family-friendly apartments near Our Children's House Elementary School at The Park at Aventino in the 27407 area. Ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165577",
      "source": "generator",
      "page_item_url": "greensboro-nc-apartments-near-new-garden-friends-school",
      "search_query": "greensboro nc apartments near new garden friends school",
      "category": "School",
      "h1_title": "Greensboro NC Apartments Near New Garden Friends School",
      "h2_subtitle": "Discover convenient living at The Park at Aventino, offering apartments near New Garden Friends School in Greensboro, NC.",
      "page_copy": "Situated in the heart of Greensboro, NC, The Park at Aventino provides ideal apartment living just a short distance from New Garden Friends School. Our location ensures that families and professionals alike benefit from an easy commute, making it easier to engage with both educational and community activities.\n\nEnjoy exceptional amenities such as a refreshing pool, modern fitness center, and scenic walking trails. Our spacious one and two-bedroom floor plans are designed to offer comfort and convenience, making The Park at Aventino a fantastic choice for anyone looking to reside close to New Garden Friends School while enjoying a vibrant Greensboro lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019d0835-cab2-76f7-856c-441d7c7e2f49",
        "storage_key": "property/6767906449165577/019d0835-cab2-76f7-856c-441d7c7e2f49.webp",
        "width": 1125,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Park at Aventino | Greensboro NC Apartments Near New Garden Friends School",
      "seo_description": "Discover spacious Greensboro NC apartments near New Garden Friends School at The Park at Aventino, with modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3166"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "4707070245"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5494326"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W2S392HL"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "336-916-9507"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "336-585-8624"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psm_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=psm"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "336-594-2669"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "336-863-9801"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "336-780-7673"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "336-948-9906"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "336-481-7263"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "336-439-3514"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psm_title",
      "type": "STRING",
      "value": "Paid Social Media Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "336-443-6923"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_gpaid_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=gpaid"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "336-967-6413"
    },
    {
      "ID": "custom_knock_psm_number",
      "type": "STRING",
      "value": "336-936-5238"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_gpaid_title",
      "type": "STRING",
      "value": "Google Paid"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "336-296-4600"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "16233550907"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "336-569-7170"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.lynxgatecity.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "4311f0bb8b8d922c"
    },
    {
      "ID": "custom_knock_gpaid_number",
      "type": "STRING",
      "value": "336-800-3798"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "336-810-0712"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449165577/019e60f8-d7b0-72cd-9b08-30b19707e647.mp4"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "336-800-3798"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3166",
  "custom_repli_id": "4707070245",
  "custom_realpage_id": "5494326",
  "custom_knock_a_link": "https://www.lynxgatecity.com?utm_knock=a",
  "custom_knock_g_link": "https://www.lynxgatecity.com?utm_knock=g",
  "custom_knock_w_link": "https://www.lynxgatecity.com?utm_knock=w",
  "custom_knock_z_link": "https://www.lynxgatecity.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-W2S392HL",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.lynxgatecity.com?utm_knock=al",
  "custom_knock_br_link": "https://www.lynxgatecity.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.lynxgatecity.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.lynxgatecity.com?utm_knock=fb",
  "custom_knock_g_title": "Google",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "336-916-9507",
  "custom_knock_ads_link": "https://www.lynxgatecity.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_g_number": "336-585-8624",
  "custom_knock_ppn_link": "https://www.lynxgatecity.com?utm_knock=ppn",
  "custom_knock_psm_link": "https://www.lynxgatecity.com?utm_knock=psm",
  "custom_knock_w_number": "336-594-2669",
  "custom_knock_z_number": "336-863-9801",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "336-780-7673",
  "custom_knock_br_number": "336-948-9906",
  "custom_knock_cl_number": "336-481-7263",
  "custom_knock_fb_number": "336-439-3514",
  "custom_knock_osoc_link": "https://www.lynxgatecity.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psm_title": "Paid Social Media Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "336-443-6923",
  "custom_knock_cfres_link": "https://www.lynxgatecity.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_gpaid_link": "https://www.lynxgatecity.com?utm_knock=gpaid",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppn_number": "336-967-6413",
  "custom_knock_psm_number": "336-936-5238",
  "custom_seo_subscription": "full_stack",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_gpaid_title": "Google Paid",
  "custom_knock_osoc_number": "336-296-4600",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "16233550907",
  "custom_knock_cfres_number": "336-569-7170",
  "custom_knock_chatgpt_link": "https://www.lynxgatecity.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "4311f0bb8b8d922c",
  "custom_knock_gpaid_number": "336-800-3798",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "336-810-0712",
  "custom_website_subscription": "turnkey",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449165577/019e60f8-d7b0-72cd-9b08-30b19707e647.mp4",
  "custom_ppc_tracking_phone_number": "336-800-3798"
};

export const generatedAt = '2026-10-07T17:12:42.268Z';
